import { useMemo } from "react";

import {
  COMPUTED_VALUE,
  EMPTY_VALUE,
  WRITE_ONLY_VALUE,
} from "components/Environment/constants/values";
import Code from "ds/components/Code";
import makeUseCellCopyAction from "ds/components/Table/helpers/makeUseCellCopyAction";
import TableCellText from "ds/components/Table/Row/CellText";

import EnvironmentTableCell from "../Cell";
import { EnvironmentVariableCellProps } from "./types";

const useCellCopyAction = makeUseCellCopyAction();

const ValueCell = ({ item, ...cellProps }: EnvironmentVariableCellProps) => {
  const { runtime, writeOnly, value } = item.element;
  const isPlainValue = !runtime && !writeOnly && !!value;

  const copyAction = useCellCopyAction({ text: value || "" });
  const actions = useMemo(() => (isPlainValue ? [copyAction] : []), [copyAction, isPlainValue]);

  let displayValue = EMPTY_VALUE;
  if (runtime) {
    displayValue = COMPUTED_VALUE;
  } else if (writeOnly) {
    displayValue = WRITE_ONLY_VALUE;
  } else if (value) {
    displayValue = value;
  }

  return (
    <EnvironmentTableCell {...cellProps} actions={actions}>
      <TableCellText>
        <Code whiteSpaceVisible>{displayValue}</Code>
      </TableCellText>
    </EnvironmentTableCell>
  );
};

export default ValueCell;
